import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Config from "../../config/Config";
import { ValidateError, ValidateSuccess } from "./interceptor_error_message";

const AUTH_EXEMPT_PATHS = [
  "katalis/login",
  "mob_user/otp_login",
  "authentication/admin/login",
  "authentication/private/admin/token",
];

const shouldSkipApiKey = (config) => {
  const requestUrl = `${config?.baseURL || ""}${config?.url || ""}`;
  return AUTH_EXEMPT_PATHS.some((path) => requestUrl.includes(path));
};

const onRequest = (config) => {
  const apiKey = (Config.ApiKey || "").trim();
  if (apiKey && !shouldSkipApiKey(config)) {
    config.headers = config.headers || {};
    if (!config.headers["X-API-KEY"] && !config.headers["x-api-key"]) {
      config.headers["X-API-KEY"] = apiKey;
    }
  }
  return config;
};

const onRequestError = (error) => {
  console.log(`[request error] [${JSON.stringify(error)}]`);
  return Promise.reject(error);
};

const onResponse = async (response) => {
  let message = "";
  if (response && response.data) {
    const data = response.data;
    message = await ValidateSuccess(data);
    if (
      response.config.url?.includes("authentication/admin/login") ||
      response.config.url?.includes("authentication/private/admin/token")
    ) {
    } else {
      toast.success(message);
    }
  }
  return response;
};

const onResponseError = async (error) => {
  const path = window.location.pathname;
  let message = "";
  if (error.response?.status === 401) {
    message = `Username dan / password salah`;
    if (path !== "/profile") toast.error(message);
  }
  if (error.response && error.response.data) {
    const data = error.response?.data;
    message = ValidateError(data, error.config);
    if (error.response?.status === 401) {
      // toast.error(path);
      if (path === "/profile")
        // toast.error('Please logout first before login with different account');
        message = `${message}. Please Login Again!`;
      else {
        message = `${message}. Please Login First!`;
        window.location.replace("/");
      }
    }
    console.log(
      error.config.url.includes("/python"),
      error.response.status == 404,
    );
    if (error.config.url.includes("/python") && error.response.status == 404)
      toast.error(`Data ${message}`);
    else if (!message?.includes("Institusi tidak aktif")) toast.error(message);
  }

  return Promise.reject(error);
};

export function setupInterceptorsTo(axiosInstance) {
  const setupFlag = "__psp_interceptors_setup__";
  if (axiosInstance[setupFlag]) return axiosInstance;
  axiosInstance[setupFlag] = true;
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}
